export const formOptions = [
  { key: 1, value: 'I’ll be out of town' },
  { key: 2, value: 'I need to cut down my budget' },
  { key: 3, value: 'I’ll have spare time to cook myself' },
  { key: 4, value: 'I will try out other service' },
  { key: 5, value: 'I am not finding the meals that I like' },
  { key: 6, value: 'I just need a break' },
  { key: 7, value: 'I am not happy with the service' }
]
